<template>
  <div class="page">
    <el-button class="mb10" type="primary" @click="closeWin">{{ $t('common.back') }}</el-button>

    <query-form label-width="90px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.designerId')">
          <el-input clearable v-model="queryForm.designerId"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.brand')">
          <brand-select multiple collapse-tags clearable v-model="queryForm.brandIds" :data="brandList" :label-prop="'englishName'"></brand-select>
        </query-form-item>
        <query-form-item :label="$t('common.category')">
          <el-cascader
            v-model="queryForm.categoryIds"
            clearable
            collapse-tags
            :props="{ value: 'categoryId', label: 'name', emitPath: false, expandTrigger: 'hover', multiple: true }"
            :options="categoryList"
            style="width: 100%"
          ></el-cascader>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <table-toolbar>
      <el-button type="primary" @click="exportExcel">{{ $t('common.excel') }}</el-button>
    </table-toolbar>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column prop="coverImg" label="" class-name="nopadding" width="120">
        <template slot-scope="scope">
          <list-img :img="scope.row.coverImg" :width="100"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="designerId" :label="$t('common.designerId')"></el-table-column>
      <el-table-column prop="colorCode" :label="$t('common.color')"></el-table-column>
      <el-table-column prop="brandName" :label="$t('common.brand')"></el-table-column>
      <el-table-column prop="categoryNamePath" :label="$t('common.category')"></el-table-column>
      <el-table-column prop="seasonCode" :label="$t('common.season')"></el-table-column>
      <el-table-column prop="productName" :label="$t('common.productName')"></el-table-column>
      <el-table-column prop="size" :label="$t('common.size')"></el-table-column>
      <el-table-column prop="totalQuantity" :label="$t('common.qty')"></el-table-column>
      <el-table-column prop="retailPrice" :label="$t('common.retailPrice')">
        <template slot-scope="scope">
          <span>€ {{ scope.row.retailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="supplyPrice" :label="$t('common.supplyPrice')">
        <template slot-scope="scope">
          <span>€ {{ scope.row.supplyPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="saleCategory" :label="$t('wholesaleOrder.saleType')">
        <template slot-scope="scope">
          <span v-if="scope.row.saleCategory === 1">{{ $t('wholesaleOrder.hotItem') }}</span>
          <span v-if="scope.row.saleCategory === 2">{{ $t('wholesaleOrder.normalItem') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {
  getWholesaleMergeDetail,
  exportWholesaleMergeList,
} from '../../api/wholesaleOrder';
import { getCategoryList, getBrandList } from '../../api/product';
import BrandSelect from '../../components/BrandSelect';
import ListImg from '../../components/ListImg';
import { downloadBlobFile } from '../../common/utils';

export default {
  components: {
    ListImg,
    BrandSelect,
  },
  data() {
    return {
      loading: false,
      categoryList: [],
      brandList: [],
      queryForm: {
        designerId: null,
        brandIds: [],
        categoryIds: [],
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      selection: [],
    };
  },
  created() {
    getBrandList().then((res) => {
      this.brandList = res.data || [];
    });
    getCategoryList().then((res) => {
      this.categoryList = res.data.map((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((item2) => {
            if (item2.children && item2.children.length > 0) {
              item2.children.forEach((item3) => {
                item3.children = item3.children.length === 0 ? null : item3.children;
              });
            } else {
              item2.children = null;
            }
          });
        } else {
          item.children = null;
        }
        return item;
      });
    });
    this.getAllData();
  },
  methods: {
    closeWin() {
      window.close();
    },
    search() {
      this.getTableData();
    },
    reset() {
      this.queryForm.designerId = null;
      this.queryForm.brandIds = [];
      this.queryForm.categoryIds = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getAllData() {
      this.loading = true;
      getWholesaleMergeDetail({
        mergeNo: this.$route.params.no,
      }).then((res) => {
        this.allData = res.data || [];
        this.total = this.allData.length;
        this.getTableData();
      });
    },
    getTableData() {
      this.loading = true;
      const data = this.allData.filter((item) => {
        if (this.queryForm.designerId && !item.designerId.includes(this.queryForm.designerId)) {
          return false;
        }
        if (this.queryForm.brandIds && this.queryForm.brandIds.length > 0 && !this.queryForm.brandIds.includes(item.brandId)) {
          return false;
        }
        if (this.queryForm.categoryIds && this.queryForm.categoryIds.length > 0 && !this.queryForm.categoryIds.includes(item.categoryId)) {
          return false;
        }
        return true;
      });
      this.tableData = data.slice((this.queryForm.pageNo - 1) * this.queryForm.pageSize, this.queryForm.pageNo * this.queryForm.pageSize);
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    exportExcel() {
      exportWholesaleMergeList({
        mergeNo: this.$route.params.no,
      }).then((res) => {
        const fileName = `${this.$route.params.no}.xlsx`;
        downloadBlobFile(res.data, fileName);
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
